import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/sivadm/user/login',
    method: 'post',
    data
  })
}

export function getInfo(openid) {
  return request({
    url: '/sivadm/user/' + openid,
    method: 'get'
    // params: { openid }
  })
}

export function logout(token) {
  return request({
    url: '/sivadm/user/logout/' + token,
    method: 'post'
  })
}

export function getRbacMe() {
  return request({
    url: '/sivadm/user/rbac/me',
    method: 'get'
  })
}

export function getAllToken(admin_uid) {
  return request({
    url: '/sivadm/user/token',
    method: 'get',
  })
}

export function getUserToken(openid) {
  return request({
    url: '/sivadm/user/token/' + openid,
    method: 'get',
    // params: { openid }
  })
}

export function removeToken(token) {
  return request({
    url: '/sivadm/user/token/' + token,
    method: 'delete',
    // params: { openid }
  })
}

export function getAllUser(admin_uid) {
  return request({
    url: '/sivadm/user/all',
    method: 'get',
    params: { admin_uid }
  })
}

export function getSubAdmins(admin_uid) {
  return request({
    url: '/sivadm/user/subadmins',
    method: 'get',
    params: { admin_uid }
  })
}

export function addUser(data) {
  return request({
    url: '/sivadm/user/',
    method: 'post',
    data
  })
}

export function removeUser(uid, admin_uid) {
  return request({
    url: '/sivadm/user/' + uid,
    method: 'delete',
    params: { admin_uid }
  })
}

export function getcode(phone) {
  return request({
    url: '/sivadm/user/smscode/' + phone,
    method: 'get'
  })
}
